import React, { useEffect, useState } from 'react';
import Chart from "react-apexcharts";
import FilterBar from './FilterBar';
import { getApplicationInsight } from '../../api/insights';
import { useDispatch, useSelector } from 'react-redux';
import { failed } from '../../utils/Tostify';
import Loader from '../../components/Loader/Loader';

const ApplicationGraph = (activeTab) => {
  const [dropdownOpenTimeline, setDropdownOpenTimeline] = useState(false);
  const toggleTimeline = () => setDropdownOpenTimeline((prevState) => !prevState);

  const [dropdownOpenMeasures, setDropdownOpenMeasures] = useState(false);
  const toggleMeasures = () => setDropdownOpenMeasures((prevState) => !prevState);

  const [dropdownOpenGroupBy, setDropdownOpenGroupBy] = useState(false);
  const toggleGroupBy = () => setDropdownOpenGroupBy((prevState) => !prevState);

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [timeline, setTimeline] = useState("Daily");
  const [measures, setMeasures] = useState("Total");
  const [groupBy, setGroupBy] = useState("Select");
  const [chartData, setChartData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  let token = useSelector(state => state.userReducer.token);
  const dispatch = useDispatch();

  useEffect(() => {
    if(activeTab.activeTab === "3"){
      fetchApplicationData();
  }
  }, [fromDate, toDate, timeline, measures, groupBy, activeTab]);

  const fetchApplicationData = async () => {
    let res;
    try {
      setIsLoading(true);
      res = await getApplicationInsight({ values : {orgId : localStorage.getItem("currentOrgId"), clinicId : localStorage.getItem("currentHospitalId"), fromDate, toDate, timeline, groupBy, measures }, dispatch, token});
      if (res?.status === "SUCCESS") {
        setChartData(res?.data);
        setIsLoading(false);
      }
    } catch (error) {
      failed(res?.message);
      setIsLoading(false);
    }
  };

  const chartOptions = {
    options: {
      chart: {
        id: "basic-bar"
      },
      xaxis: {
        categories: chartData.map((item) => item.date)
      }
    },
    series: [{
      data: [{
        x: 'Day 1',
        y: 10
      }, {
        x: 'Day 2',
        y: 18
      }, {
        x: 'Day 3',
        y: 19
      }, {
        x: 'Day 4',
        y: 14
      }, {
        x: 'Day 5',
        y: 11
      }, {
        x: 'Day 6',
        y: 13
      }]
    }]
  };
  const pieOptions = {
    options: {
      theme: {
        // mode: 'light',
        palette: 'palette2',
        monochrome: {
            // enabled: false,
            // color: '#255aee',
            // shadeTo: 'light',
            shadeIntensity: 0.6
      }
    }
    },
    series: [44, 55, 41, 17, 15],
    labels: ['A', 'B', 'C', 'D', 'E']
  };

  return (
    <>
      <div className="d-flex justify-content-center align-items-center mb-4 pt-4">
        <h4>Applications</h4>
        </div>
        {isLoading ? <Loader /> : null}
        <div className="d-flex gap-3 flex-wrap">
        <div className="graph_block">
          <div className="d-flex justify-content-end align-items-center gap-4">
          <FilterBar
              fromDate={fromDate}
              setFromDate={setFromDate}
              toDate={toDate}
              setToDate={setToDate}
              timeline={timeline}
              setTimeline={setTimeline}
              dropdownOpenTimeline={dropdownOpenTimeline}
              toggleTimeline={toggleTimeline}
              measures={measures}
              setMeasures={setMeasures}
              dropdownOpenMeasures={dropdownOpenMeasures}
              toggleMeasures={toggleMeasures}
              groupBy={groupBy}
              setGroupBy={setGroupBy}
              dropdownOpenGroupBy={dropdownOpenGroupBy}
              toggleGroupBy={toggleGroupBy}
            />
          </div>
          <div className="chart-apex">
            <Chart
              options={chartOptions.options}
              series={chartOptions.series}
              type="bar"
              width="100%"
              height="400"
            />
          </div>
        </div>
      </div>
      <div className="piechart_block d-flex gap-2 flex-wrap">
        {[...Array(3)].map((_, index) => (
          <div className="piechart_one" key={index}>
            <Chart options={pieOptions.options} series={pieOptions.series} type="pie" width="380" />
          </div>
        ))}
      </div>
    </>
  );
};

export default ApplicationGraph;
